let resumeData = {
    "imagebaseurl":"https://umesh-react-portfolio.netlify.app/",
    "name": "Umesh Yadav",
    "role": "Full Stack Web Developer",
    "linkedinId":"https://www.linkedin.com/in/umesh-yadav-618256b6/",
    "skypeid": "Your skypeid",
    "roleDescription": "I like dabbling in various parts of frontend development and like to learn about new technologies, Outside of Development I love to do hiking, play Badminton and Cricket and else I watch information videos related to popular things.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/umesh-yadav-618256b6/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/umeshyadavrocks",
          "className":"fa fa-github"
        }
      ],
    "aboutme":"I am currently pursuing Full Stack Web Development Course at Masai School. Currently diving deeper into MERN Learning. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
    "address":"umeshramyadav7771@gmail.com",
    "website":"",
    "education":[
      {
        "UniversityName":"Pune University",
        "specialization":"Bachelor of Science(Comp.Sci)",
        "MonthOfPassing":"March",
        "YearOfPassing":"2018",
      },
      {
        "UniversityName":"Maharashtra State Board",
        "specialization":"Higher Secondary School",
        "MonthOfPassing":"March",
        "YearOfPassing":"2012",
      }
    ],

   

    "portfolio":[
      {
        "name":"Lyst Clone",
        "description":"U.S Based Clothing Website which delivers products Worldwide.",
        "imgurl":"images/lyst.png",
        "gitrepo" : "https://github.com/V-bhoy/Lyst-clone",
        "prolink" : "https://lyst-clone.netlify.app/",
        "webimg" : "images/web.png"
      },
      {
        "name":"Myntra Clone",
        "description":"An E-Commerce Site of Clothes & Apparels.",
        "imgurl":"images/myntra.png",
        "gitrepo" : "https://github.com/jatindevnani/Myntra-clone",
        "prolink" : "https://myntra-x1.netlify.app/",
        "webimg" : "images/web.png"
      },
      {
        "name":"Freshly Clone",
        "description":"A New-York based Meal Planning Site.",  
        "imgurl":"images/freshly.png",
        "gitrepo" : "https://github.com/umeshyadavrocks/freshlyClone",
        "prolink" : "https://reliable-gecko-cc08b3.netlify.app/",
        "webimg" : "images/web.png"
      }
    ],
    
  }
  
  export default resumeData